import { useEffect, useState } from 'react'
import { Button, LoadingSpinner } from './BaseComponents'
import CanonicalModal from './BaseComponents/CanonicalModal/CanonicalModal'
import { DELEGATED_ACCESS_LEVEL_LABELS, DelegatedAccessLevel } from '../lib/delegatedAccess'

type DelegatedAccessLevelModalProps = {
	open: boolean
	title: string
	subtitle?: string
	confirmText: string
	initialLevel: DelegatedAccessLevel
	loading?: boolean
	onConfirm: (level: DelegatedAccessLevel) => void
	onClose: () => void
}

const LEVEL_DESCRIPTIONS: Record<DelegatedAccessLevel, string> = {
	view: 'They can see everything in your organisation but cannot change anything.',
	edit: 'They can see and change your organisation’s data.',
}

function DelegatedAccessLevelModal({
	open,
	title,
	subtitle,
	confirmText,
	initialLevel,
	loading,
	onConfirm,
	onClose,
}: DelegatedAccessLevelModalProps) {
	const [level, setLevel] = useState<DelegatedAccessLevel>(initialLevel)

	useEffect(() => {
		if (open) {
			setLevel(initialLevel)
		}
	}, [open, initialLevel])

	return (
		<CanonicalModal
			open={open}
			onClose={onClose}
			title={title}
			subtitle={subtitle}
			actions={
				<>
					<Button
						type='Primary'
						size='sm'
						text={confirmText}
						disabled={loading}
						onClick={() => onConfirm(level)}
						additionalClass='mr-5'
					/>
					<Button type='Outlined' size='sm' text='Cancel' onClick={onClose} />
				</>
			}
		>
			{loading ? (
				<LoadingSpinner />
			) : (
				<fieldset className='mt-8'>
					<legend className='text-white mb-2'>Access level</legend>
					{(Object.keys(DELEGATED_ACCESS_LEVEL_LABELS) as DelegatedAccessLevel[]).map((option) => (
						<label key={option} className='flex items-start text-white mb-3 cursor-pointer'>
							<input
								type='radio'
								name='delegatedAccessLevel'
								value={option}
								checked={level === option}
								onChange={() => setLevel(option)}
								className='mt-1 mr-3'
							/>
							<span>
								<span className='block'>{DELEGATED_ACCESS_LEVEL_LABELS[option]}</span>
								<span className='block text-sm text-charcoal-100'>{LEVEL_DESCRIPTIONS[option]}</span>
							</span>
						</label>
					))}
				</fieldset>
			)}
		</CanonicalModal>
	)
}

export default DelegatedAccessLevelModal
